import { yearsCoding, projectCount, languagesSpoken } from './profile.js';

const metrics = [
  { id: 'm1', tKey: 'metrics.m1', value: yearsCoding,       suffix: '+', label: 'Years' },
  { id: 'm2', tKey: 'metrics.m2', value: projectCount,      suffix: '+', label: 'Projects' },
  { id: 'm3', tKey: 'metrics.m3', value: languagesSpoken,   suffix: '',  label: 'Languages' },
  { id: 'm4', tKey: 'metrics.m4', value: Infinity,          suffix: '',  label: 'Coffee' },
];

export default metrics;
